import _ from 'lodash';
import template from './scheduleModal.html';

const component = {
  name: 'scheduleModal',
  template,
  controller: ScheduleModalController,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};

/* @ngInject */
function ScheduleModalController(growl) {
  const vm = this;
  const types = {
    pumps: [{
      name: 'On',
      value: 'setCloudOn'
    }, {
      name: 'Off',
      value: 'setCloudOff'
    }, {
      name: 'Local',
      value: 'setLocal'
    }],
    shutoff: [{
      name: 'Schedule On',
      value: 'scheduleOn'
    }, {
      name: 'Schedule Off',
      value: 'scheduleOff'
    }],
    gates: [{
      name: 'Hold Close',
      value: 'holdClose'
    }, {
      name: 'Hold Open',
      value: 'holdOpen'
    }, {
      name: 'Keypad / Card',
      value: 'holdNormal'
    }]
  };

  vm.$onInit = init;
  vm.saveDialSchedule = saveDialSchedule;
  vm.addDialSchedule = addDialSchedule;
  vm.removeSchedule = removeSchedule;

  function init() {
    vm.options = vm.resolve.options;

    vm.timer = {
      id: vm.options.eq.id || vm.options.eq.equipment.id,
      options: [],
      events: []
    };
    if (_.isBoolean(vm.options.scheduleEnabled)) {
      vm.timer.isEnabled = vm.options.scheduleEnabled;
    }

    vm.timer.options = getScheduleOptionsObject(vm.options.eq.equipmentType || vm.options.eq.equipment.equipmentType);
    if (_.get(vm.options.scheduleSettings, 'length')) {
      vm.timer.events = angular.copy(vm.options.scheduleSettings);
    } else {
      addDialSchedule();
      vm.timer.events[0].mode = vm.timer.options[0].value;
    }
  }

  function saveDialSchedule() {
    const dontSave = _.some(vm.timer.events, obj => obj.mode === null || obj.mode === '');

    if (dontSave) {
      growl.warning('One or more of the modes are not set. Please set all modes and save.');
    } else {
      vm.close({
        $value: {
          scheduleSettings: vm.timer.events,
          scheduleEnabled: vm.timer.isEnabled
        }
      });
    }
  }

  function addDialSchedule() {
    vm.timer.events.push({
      mode: '',
      cron: '0 * * * *'
    });
  }

  function removeSchedule(ind) {
    vm.timer.events.splice(ind, 1);
  }

  function getScheduleOptionsObject(type) {
    return types[type];
  }
}

export default component;
